import {create} from 'zustand'
import {persist} from 'zustand/middleware'

export type DebugModes = 'none' | 'data' | 'design' | 'feature' | 'footnote'

interface DebugState {
  mode: DebugModes
  isDebugOnMode: (mode: DebugModes) => boolean
}

export const useDebugStore = create<DebugState>()(
  persist((set, get) => ({
    mode: 'none',
    isDebugOnMode: (mode) => get().mode === mode,
  }),
  {
    name: 'debug',
  }),
)
